import React, { useState, useEffect } from "react";
import { Grid } from "fluentui-react-grid";
import SaveButton from "@/ui-controls/SaveButton";
import CancelButton from "@/ui-controls/CancelButton";
import TextInput from "@/ui-controls/TextInput";
import AddButton from "@/ui-controls/AddButton";
import { Privilege } from "@/api/privileges";
import { Application } from "@/api/applications";
import { addRolePrivileges, Role, RolePrivileges } from "@/api/roles";
import PrivilegeSelectDetailList from "@/components/privileges/appRolePrivileges/PrivilegeSelectDetailList";

interface Props {
  application: Application;
  role: Role;
  allAppPrivileges: Privilege[];
  unassignedAppPrivileges: Privilege[];
  onAddNewPrivilege?: (privilege: Privilege) => any;
  onSave?: (newRolePrivileges: RolePrivileges) => any;
  onClose?: () => any;
}

const NewAppRolePrivilegeForm = (props: Props) => {
  const [showNewAppPrivilegeForm, setShowNewAppPrivilegeForm] =
    useState<boolean>(false);
  const [filteredPrivilegeValue, setFilteredPrivilegeValue] = useState<
    string | undefined
  >(undefined);
  const [filteredPrivileges, setFilteredPrivileges] = useState<Privilege[]>([]);
  const [selectedPrivileges, setSelectedPrivileges] = useState<Privilege[]>([]);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  useEffect(() => {
    filterPrivileges(filteredPrivilegeValue);
  }, [props.unassignedAppPrivileges]);

  const onFilter = (
    ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    text: string | undefined
  ) => {
    setFilteredPrivilegeValue(text);
    filterPrivileges(text);
  };

  const filterPrivileges = (text: string | undefined) => {
    setFilteredPrivileges(
      text
        ? props.unassignedAppPrivileges.filter(
            (i) => i.Name.toLowerCase().indexOf(text.toLowerCase()) > -1
          )
        : props.unassignedAppPrivileges
    );
  };

  const saveRolePrivileges = () => {
    setIsSaving(true);

    const rolePrivileges: RolePrivileges = {
      RoleId: props.role.Id,
      PrivilegeIds: selectedPrivileges.map((c) => c.Id),
    };

    addRolePrivileges(rolePrivileges).then(
      (_) => {
        setIsSaving(false);
        if (props.onSave) props.onSave(rolePrivileges);
      },
      (error) => {
        setIsSaving(false);
        handleError(error);
      }
    );
  };

  const onCancelForm = () => {
    if (props.onClose) props.onClose();
  };

  const handleError = (error: any) => {
    // Error handling would go here in real app
  };

  return (
    <>
      {/* {showNewCustomerForm && filteredCustomerValue ? (
        <NewCustomerForm
          name={filteredCustomerValue}
          onClose={() => {
            setShowNewCustomerForm(false);
            filterPrivileges(filteredPrivilegeValue);
          }}
          onSave={(newCustomer) => {
            setShowNewCustomerForm(false);
            if (props.onAddNewCustomer) props.onAddNewCustomer(newCustomer);
          }}
        />
      ) : null} */}
      <div style={{ display: showNewAppPrivilegeForm ? "none" : "block" }}>
        <Grid dir="ltr">
          <Grid.Row>
            <Grid.Col sizeSm={12}>
              <TextInput
                label="Filter privileges:"
                baseTypeProps={{
                  onChange: onFilter,
                }}
              />
              {/* {validateCustomerToAdd(filteredCustomerValue) ? (
                <div
                  style={{
                    position: "absolute",
                    top: "29px",
                    right: "8px",
                  }}
                >
                  <AddButton
                    text="Add"
                    onClick={() => setShowNewCustomerForm(true)}
                    baseTypeProps={{ disabled: isSaving }}
                  />
                </div>
              ) : null} */}
            </Grid.Col>
          </Grid.Row>
          <Grid.Row>
            <PrivilegeSelectDetailList
              appPrivileges={filteredPrivileges}
              onSelectionChanged={(privileges) => {
                setSelectedPrivileges(privileges);
              }}
            />
          </Grid.Row>
          <Grid.Row className="panel-buttons">
            <Grid.Col>
              <SaveButton
                text="Save"
                baseTypeProps={{
                  disabled:
                    isSaving ||
                    !selectedPrivileges ||
                    selectedPrivileges.length < 1,
                }}
                onClick={() => saveRolePrivileges()}
              />
            </Grid.Col>
            <Grid.Col>
              <CancelButton
                text="Cancel"
                onClick={onCancelForm}
                baseTypeProps={{ disabled: isSaving }}
              />
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </div>
    </>
  );
};

export default NewAppRolePrivilegeForm;
